import type { Role } from "@soulbyte/core";
import { useAuth } from "@frontegg/react";

export function useHasRole(role: Role) {
  const { user } = useAuth();
  if (!user) return false;
  return user.roles.some((r) => r.name === role);
}

/** True for moderators, admins and super admins — everyone above a plain user. */
export function useIsStaff() {
  const isModerator = useHasRole("Moderator");
  const isAdmin = useHasRole("Admin");
  const isSuperAdmin = useHasRole("SuperAdmin");
  return isModerator || isAdmin || isSuperAdmin;
}
